import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Link } from "gatsby";
import React from "react";
import { MenuLink } from "../types/types";

export interface FlyoutNavProps {
  link: MenuLink;
}

const HOVER_TIMOUT = 250;

const FlyoutNav: React.FC<FlyoutNavProps> = ({ link }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const hoverTimeout = React.useRef<NodeJS.Timeout>(null);

  React.useEffect(() => {
    return () => {
      if (hoverTimeout.current) {
        clearTimeout(hoverTimeout.current);
      }
    };
  }, []);

  const handleMouseEnter = React.useCallback(() => {
    setIsOpen(true);
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    setIsClosing(true);
    hoverTimeout.current = setTimeout(() => {
      setIsClosing(false);
      setIsOpen(false);
    }, HOVER_TIMOUT);
  }, []);

  const handleClickMain = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleClickSub = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Popover className="relative">
      <PopoverButton className="cursor-pointer nav-link">
        {link.label}
      </PopoverButton>
      <PopoverPanel
        anchor="bottom"
        className="p-2 space-y-2 text-sm bg-white rounded-lg border transition duration-200 ease-in-out z-100 border-stone-200 data-closed:-translate-y-1 data-closed:opacity-0"
      >
        {link.subnavigation!.map((child) => (
          <Link
            key={child.slug}
            to={child.slug}
            onClick={handleClickSub}
            className="block py-2 pr-8 pl-2 text-sm rounded transition-colors text-stone-700 hover:text-stone-800 hover:bg-stone-100"
            activeClassName="bg-primary-500 !text-white hover:!bg-primary-500 hover:!text-white"
            partiallyActive={true}
          >
            {child.label}
          </Link>
        ))}
      </PopoverPanel>
    </Popover>
  );
};

export default FlyoutNav;
